import React from "react";
import { Link } from "react-router-dom";

function KeyUpdates() {
  return (
    <div className="container">
      <div className="card policy-card">
        <Link to="/" className="back-link">
          &larr; Back
        </Link>

        <h1>Summary of Key Updates</h1>

        <p className="description">
          While the core principles of our Privacy Policy remain unchanged, the
          updated version includes several clarifications and additional detail,
          including:
        </p>

        <h2>Expanded description of personal data collected</h2>
        <p>
          The policy now provides additional detail about the categories of data
          we may collect, for example identity data and website usage data.
        </p>

        <h2>
          Further explanation of how information may be obtained
        </h2>
        <p>
          The policy clarifies the different ways personal information may be
          collected, including directly from you, through website forms, from
          third-party providers and from publicly available sources where
          appropriate.
        </p>

        <h2>
          Additional detail regarding lawful bases for processing
        </h2>
        <p>
          The updated policy provides a more detailed description of the legal
          grounds under which personal data may be processed, including
          contractual necessity, legitimate interests, legal obligations and
          consent.
        </p>

        <h2>Additional information regarding data sharing</h2>
        <p>
          The policy now provides further explanation of the categories of third
          parties with whom data may be shared in order to provide our services,
          including professional advisers, compliance partners, credit reference
          agencies and other service providers.
        </p>

        <h2>Marketing communications and preferences</h2>
        <p>
          The policy includes updated information regarding the lawful bases on
          which we may send marketing communications and the options available to
          you to manage your marketing preferences.
        </p>

        <h2>Website cookies and analytics</h2>
        <p>
          The updated policy includes additional information regarding the use of
          cookies and website analytics tools.
        </p>

        <h2>Retention guidance</h2>
        <p>
          The policy clarifies how long personal data may be retained, including
          the retention of information relating to legal matters where required
          for legal or regulatory purposes.
        </p>
      </div>
    </div>
  );
}

export default KeyUpdates;
